module.exports = __webpack_public_path__ + "static/media/electric-fun.dfcb9f4e.svg";